
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","d":"M0 0h24v24H0z"}}),_c('path',{attrs:{"data-name":"Union 8","d":"M11.996 13.428l-3.572 3.573-1.426-1.429L10.568 12l-3.57-3.571L8.424 7l3.572 3.571L15.566 7l1.426 1.429-3.568 3.569 3.574 3.574-1.432 1.429z","fill":"currentColor"}})])
          )
        }
      }
    